import { useState, useCallback } from "react";
import {
  archiveContact,
  unarchiveContact,
} from "../../../../../../../services/contacts";

const ARCHIVE_SUCCESS = {
  title: "The contact has been archived successfully.",
  message: "The contact is now archived and removed from your active list.",
  severity: "success",
};

const ARCHIVE_ERROR = {
  title: "Unable to archive contact",
  message:
    "Something went wrong while archiving this contact. Please try again.",
  severity: "error",
};

const UNARCHIVE_SUCCESS = {
  title: "Contact restored to active status",
  message: "The contact is active again.",
  severity: "success",
};

const UNARCHIVE_ERROR = {
  title: "Action couldn't be completed",
  message: "Action couldn't be completed, please try again.",
  severity: "error",
};

export const useArchiveContact = (setAlert) => {
  const [archivedSet, setArchivedSet] = useState(() => new Set());

  const isArchived = useCallback(
    (partyUuid) => archivedSet.has(partyUuid),
    [archivedSet],
  );

  const handleToggleArchive = useCallback(
    async (contact) => {
      const { partyUuid } = contact;
      const currentlyArchived = archivedSet.has(partyUuid);

      try {
        if (currentlyArchived) {
          await unarchiveContact(partyUuid);
          setArchivedSet((prev) => {
            const next = new Set(prev);
            next.delete(partyUuid);
            return next;
          });
          setAlert(UNARCHIVE_SUCCESS);
        } else {
          await archiveContact(partyUuid);
          setArchivedSet((prev) => new Set(prev).add(partyUuid));
          setAlert(ARCHIVE_SUCCESS);
        }
      } catch {
        setAlert(currentlyArchived ? UNARCHIVE_ERROR : ARCHIVE_ERROR);
      }
    },
    [archivedSet, setAlert],
  );

  return { archivedSet, isArchived, handleToggleArchive };
};
